import React, { useCallback, useState } from 'react';

import PurchaseDetailLoaderView from 'modules/purchases/PurchaseDetailLoaderView';
import { deliveryFeesIncludeServiceFees } from 'modules/purchases/utils';

import { ReviewsTableProps, ReviewTableItem } from './hooks/useVenueReviewsTableProps';
import InfiniteTable from '../tables/InfiniteTable';

export const VenueReviewsTable = ({
  className,
  items,
  fetchingNextPage,
  fetchingPreviousPage,
  sort,
  onFetchNextPage,
  onFetchPreviousPage,
  columns,
  venue,
  sentOffers,
  onSendOffer,
}: ReviewsTableProps) => {
  const [purchaseId, setPurchaseId] = useState<string | undefined>(undefined);
  const onSelect = useCallback((record: ReviewTableItem) => {
    setPurchaseId(record.purchaseId);
  }, []);

  const shouldDeliveryFeesIncludeServiceFees = deliveryFeesIncludeServiceFees(venue.country);

  return (
    <>
      {purchaseId && (
        <PurchaseDetailLoaderView
          onClose={() => setPurchaseId(undefined)}
          selectedPurchaseId={purchaseId}
          showDeliveryFees
          shouldDeliveryFeesIncludeServiceFees={shouldDeliveryFeesIncludeServiceFees}
          venue={venue}
          sentOffer={sentOffers?.find(offer => offer.purchase_id.$oid === purchaseId)}
          onSendOffer={onSendOffer}
        />
      )}
      <InfiniteTable
        onSelect={onSelect}
        className={className}
        items={items}
        fetchingNextPage={fetchingNextPage}
        fetchingPreviousPage={fetchingPreviousPage}
        onFetchNextPage={onFetchNextPage}
        onFetchPreviousPage={onFetchPreviousPage}
        sort={sort}
        visibleRowsCount={10}
        columns={columns}
      />
    </>
  );
};
